import { Button } from 'antd-mobile';


export function BpmButton(props) {
  const { content } = props
  return <Button
    block
    type='submit'
    color='primary'
    size='large'
    shape='rounded'
    {...props}
  >
    {content}
  </Button>
} 